// Enum representing the status of a file upload download per terminal.
export enum FileUploadDownloadStatus {
  Pending = 0,
  Downloading = 1,
  Success = 2,
  Failed = 3,
  Cancelled = 4,
}
